import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { scrollTo } from '@/utils/scroll-to';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "total", void 0);
    _defineProperty(_this, "page", void 0);
    _defineProperty(_this, "limit", void 0);
    _defineProperty(_this, "pageSizes", void 0);
    _defineProperty(_this, "layout", void 0);
    _defineProperty(_this, "background", void 0);
    _defineProperty(_this, "autoScroll", void 0);
    _defineProperty(_this, "hidden", void 0);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "currentPage",
    get: function get() {
      return this.page;
    },
    set: function set(value) {
      this.$emit('update:page', value);
    }
  }, {
    key: "pageSize",
    get: function get() {
      return this.limit;
    },
    set: function set(value) {
      this.$emit('update:limit', value);
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(value) {
      this.$emit('pagination', {
        page: this.currentPage,
        limit: value
      });
      if (this.autoScroll) {
        scrollTo(0, 800);
      }
    }
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(value) {
      this.$emit('pagination', {
        page: value,
        limit: this.pageSize
      });
      if (this.autoScroll) {
        scrollTo(0, 800);
      }
    }
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], default_1.prototype, "total", void 0);
__decorate([Prop({
  default: 1
})], default_1.prototype, "page", void 0);
__decorate([Prop({
  default: 20
})], default_1.prototype, "limit", void 0);
__decorate([Prop({
  default: function _default() {
    return [10, 20, 30, 50];
  }
})], default_1.prototype, "pageSizes", void 0);
__decorate([Prop({
  default: 'total, sizes, prev, pager, next, jumper'
})], default_1.prototype, "layout", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "background", void 0);
__decorate([Prop({
  default: true
})], default_1.prototype, "autoScroll", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "hidden", void 0);
default_1 = __decorate([Component({
  name: 'Pagination'
})], default_1);
export default default_1;